import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import { ApiResponse } from 'src/app/main/_models/api-response';

@Injectable({
	providedIn: 'root'
})
export class AppDriverService {

	constructor(private http: HttpClient,
		private config: AppConfig) { }

	getDriverNewServices() {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/drivers/services/assigned`);
	}

	getDriverOldServices(s: Number) {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/drivers/services/assigned?s=${s}`);
	}

	getDriverService(id: Number) {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/drivers/services/assigned/` + id);
	}

	driverReply(request) {
		return this.http.put<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/drivers/services/reply`, request);
	}

	driverServiceTracking(request) {
		return this.http.post<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/drivers/services/tracking`, request);
	}

	pdf(id: number) {
		return this.http.post<Blob>(`${this.config.getConfig("apiEndpoint")}/document`, { tipo_documento: 'driver_servizio', output: "PDF", id: id }, { responseType: "blob" as "json" });
	}

	generateCartelloAutista(id: number) {
		return this.http.post<Blob>(`${this.config.getConfig("apiEndpoint")}/document`, { tipo_documento: 'cartello_autista', output: "PDF", id: id }, { responseType: "blob" as "json" });
	}
}
